import React from 'react';
export default function BankDetails(_ref) {
  var appProps = _ref.appProps,
    bankDetails = _ref.bankDetails,
    hideExtraInfo = _ref.hideExtraInfo;
  return /*#__PURE__*/React.createElement("div", {
    className: "bank-details-wrapper flex-box flex-column",
    style: hideExtraInfo ? {} : {
      marginBottom: 20
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "bold",
    style: {
      marginBottom: 10
    }
  }, Store.translations.bank_accounts), /*#__PURE__*/React.createElement("div", {
    className: "bank-details flex-box ".concat(!hideExtraInfo ? 'flex-column' : ''),
    style: hideExtraInfo ? {} : {
      background: '#f9f9f9',
      padding: '10px 20px'
    }
  }, bankDetails.map(function (detail, index) {
    var _detail$translations$, _detail$translations$2, _detail$translations$3, _detail$translations$4, _detail$translations$5, _detail$translations$6;
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "bank-detail flex-box flex-wrap",
      style: {
        marginBottom: 10
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex-box flex-1 ".concat(!hideExtraInfo ? 'flex-column' : '')
    }, !hideExtraInfo && /*#__PURE__*/React.createElement("div", {
      className: "bold"
    }, Store.translations.bank_name), /*#__PURE__*/React.createElement("div", {
      style: !hideExtraInfo ? {} : {
        marginRight: 10
      }
    }, (_detail$translations$ = (_detail$translations$2 = detail.translations.find(function (item) {
      return item.locale === appProps.currentLocale;
    })) === null || _detail$translations$2 === void 0 ? void 0 : _detail$translations$2.bankName) !== null && _detail$translations$ !== void 0 ? _detail$translations$ : detail.translations[0].bankName)), !hideExtraInfo && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "flex-box flex-column",
      style: {
        width: '50%'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "bold"
    }, Store.translations.account_name), /*#__PURE__*/React.createElement("div", null, (_detail$translations$3 = (_detail$translations$4 = detail.translations.find(function (item) {
      return item.locale === appProps.currentLocale;
    })) === null || _detail$translations$4 === void 0 ? void 0 : _detail$translations$4.accountName) !== null && _detail$translations$3 !== void 0 ? _detail$translations$3 : detail.translations[0].accountName)), /*#__PURE__*/React.createElement("div", {
      className: "flex-box flex-column",
      style: {
        width: '50%'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "bold"
    }, Store.translations.account_number), /*#__PURE__*/React.createElement("div", null, detail.accountNumber)), /*#__PURE__*/React.createElement("div", {
      className: "flex-box flex-column",
      style: {
        width: '50%'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "bold"
    }, Store.translations.iban), /*#__PURE__*/React.createElement("div", null, detail.iban)), /*#__PURE__*/React.createElement("div", {
      className: "flex-box flex-column",
      style: {
        width: '50%'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "bold"
    }, Store.translations.swift_code), /*#__PURE__*/React.createElement("div", null, detail.swiftCode)), /*#__PURE__*/React.createElement("div", {
      className: "flex-box flex-column",
      style: {
        width: '100%'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "bold"
    }, Store.translations.additional_details), /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: (_detail$translations$5 = (_detail$translations$6 = detail.translations.find(function (item) {
          return item.locale === appProps.currentLocale;
        })) === null || _detail$translations$6 === void 0 ? void 0 : _detail$translations$6.additionalDetails) !== null && _detail$translations$5 !== void 0 ? _detail$translations$5 : detail.translations[0].additionalDetails
      }
    }))));
  })));
}